import { useEffect } from "react";
import FilingNotificationService from "../../../../../../services/sockets/notifications/FilingNotificationService";

export function useFilingNotifications(filingUuid, isCpa, fetchData) {
  useEffect(() => {
    if (!filingUuid) return;

    // 1. Determine socket path based on user role
    const socketPath = isCpa ? "/ws/filing/provider" : "/ws/filing/taxpayer";
    const socketService = new FilingNotificationService(socketPath);

    // 2. Subscribe to the message stream
    const subscription = socketService.getMessages().subscribe((message) => {
      const notification = message?.message || message;

      // 3. Normalize the notification type
      const notificationType = (
        notification?.avatar ||
        notification?.type ||
        notification?.event_type ||
        notification?.notification_type ||
        ""
      ).toUpperCase();

      // 4. Extract filing ID from the notification link or payload
      const notificationLink = notification?.link || "";
      const linkMatch = notificationLink.match(/filing\/([a-f0-9-]+)/i);
      const messageFilingUuid = linkMatch
        ? linkMatch[1]
        : notification?.filing_id || notification?.filingUuid;

      // 5. Define refresh triggers
      const isSignatureNotification =
        notificationType.includes("SIGNATURE") ||
        [
          "SA",
          "SIGNATURE_AUTHORIZATION",
          "SC",
          "SIGNATURE AUTHORIZATION COMPLETED",
        ].includes(notificationType);

      const isDocumentNotification = [
        "SD",
        "NEW DOCUMENT",
        "DD",
        "DOCUMENT_DELETED",
      ].includes(notificationType);

      const isEfileAcceptedNotification = ["EA", "EFILE_ACCEPTED"].includes(
        notificationType,
      );

      // 6. Check if this notification belongs to the current filing
      const filingUuidMatches =
        messageFilingUuid && String(messageFilingUuid) === String(filingUuid);

      const isScNotification =
        notificationType === "SC" ||
        notificationType === "SIGNATURE AUTHORIZATION COMPLETED";

      // 7. Trigger refresh if criteria are met
      if (
        (isSignatureNotification ||
          isDocumentNotification ||
          isEfileAcceptedNotification) &&
        (filingUuidMatches || isScNotification)
      ) {
        fetchData();
      }
    });

    // 8. Cleanup: Unsubscribe when the component unmounts or UUID changes
    return () => subscription.unsubscribe();
  }, [filingUuid, isCpa, fetchData]);
}
